import { ModalController, ToastController } from "@ionic/angular";
import { CalendarComponentOptions } from "ion2-calendar";
import { Component, Input, OnInit } from "@angular/core";

import * as moment from 'moment';
import { MessageDisplayUtil } from "src/message-display-utils";
import { Platform } from "@ionic/angular";

@Component({
  selector: 'app-package-details',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})

export class DateRangePicker implements OnInit {
  @Input() selectedDate: any;
  @Input() optionsRange: CalendarComponentOptions;
  @Input() maxDays: number;

  constructor(private modalCtrl: ModalController,
    private platform: Platform,
    private toastCtrl: ToastController ) { }


  ngOnInit(): void {

  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  apply() {
      let _startDate = moment(this.selectedDate?.from);
      let _endDate = moment(this.selectedDate?.to);
      let _diff = _endDate.diff(_startDate, 'days');
      console.debug("selectedDate: ", this.selectedDate, _diff, this.maxDays );
      if(_diff >= this.maxDays) {
        MessageDisplayUtil.showErrorToast(`Select date within ${this.maxDays} days`,
        this.platform,
        this.toastCtrl,
        3000,
        'bottom' );
        return;
      }
    this.modalCtrl.dismiss({
      'selectedDate': this.selectedDate
    });
  }

}
